import * as Yup from 'yup';
import validation from 'modules/v2/common/validationSchema';

export const validationSchema = Yup.object().shape({
  name: validation.templateName,
  subject: validation.templateSubject,
  content: validation.templateContent,
});
